export const mutations = {
  addArticle (state, article) {
    state.article = article
  },
  setArticle (state, article) {
    state.article = article
  },
    addArticles(state, article){
    state.articles = [ ...article ]
  },
}
